import { animate, state, style, transition, trigger } from '@angular/animations';
import { ApplicationRef, Component, ElementRef, NgZone, Renderer, ViewChild } from '@angular/core';
import { Router } from '@angular/router';
import { TranslateService } from '@ngx-translate/core';
import { LocalStorageService } from 'angular-2-local-storage';
import { LoyaltyCardService } from 'app/services/loyalty/loyalty-card.service';
import { UsersService } from 'app/services/user/users.service';
import { MenuService } from 'app/services/utils/menu.service';
import { NgxLocalizedNumbersService } from 'ngx-localized-numbers/localized-numbers.service';
import { SelectItem } from 'primeng/components/common/api';
import { OverlayPanel } from 'primeng/primeng';
import { AuthService } from '../../services/user/auth.service';
import { UsersComponent } from '../administration/users/users.component';
import { LoginComponent } from '../login/login.component';
import { MenuComponent } from '../menu/menu.component';
import { AppComponent } from './../../app.component';
import { environment } from 'environments/environment';


@Component({
  templateUrl: 'homepage.html',
  selector: 'app-homepage',
  animations: [
    trigger('profile', [
      state('hidden', style({
        display: 'none'
      })),
      state('visible', style({
        display: 'block'
      })),
      transition('visible <=> hidden', animate('100ms cubic-bezier(0.86, 0, 0.07, 1)'))
    ]),
    trigger('submenu', [
      state('hidden', style({
        height: '0px'
      })),
      state('visible', style({
        height: '*'
      })),
      transition('visible => hidden', animate('400ms cubic-bezier(0.86, 0, 0.07, 1)')),
      transition('hidden => visible', animate('400ms cubic-bezier(0.86, 0, 0.07, 1)'))
    ])
  ],
  styles:[
    `


.logo {
  display: flex;
  flex-direction: column;
  align-items: center;
  padding: 20px 20px 24px;
  margin-bottom: 8px;
}

.version-chip {
  display: flex;
  align-items: center;
  gap: 5px;
  margin-top: 10px;
  background: rgba(255, 255, 255, 0.06);
  border: 0.5px solid rgba(254, 198, 92, 0.35);
  border-radius: 6px;
  padding: 4px 10px 4px 8px;
}

.version-dot {
  width: 6px;
  height: 6px;
  border-radius: 50%;
  background: #fec65c;
  flex-shrink: 0;
  animation: version-pulse 2.2s ease-in-out infinite;
}

@keyframes version-pulse {
  0%, 100% { opacity: 1;   transform: scale(1);    }
  50%       { opacity: 0.5; transform: scale(0.75); }
}

.version-text {
  font-size: 11px;
  font-weight: 500;
  color: rgba(254, 198, 92, 0.85);
  letter-spacing: 0.03em;
}

/*
.app-version {
  margin-top: 6px;
  font-size: 12px;
  color: #7a5a10;
  background: #fec65c;
  padding: 2px 8px;
  border-radius: 10px;
  display: inline-block;
}

.ribbon {
  position: relative;
  width: 100%;
  background: #fec65c;
  color: #7a5a10;
  padding: 4px 0;
  font-size: 11px;
  font-weight: 600;
  text-align: center;
  margin-top: 10px;
}

.ribbon::before,
.ribbon::after {
  content: "";
  position: absolute;
  bottom: -5px;
  border-top: 5px solid #d9a94a;
  border-left: 5px solid transparent;
  border-right: 5px solid transparent;
}

.ribbon::before {
  left: 0;
}

.ribbon::after {
  right: 0;
}

.logo {
  margin-bottom: 30px;
}
*/

    `
  ]
})




export class HomepageComponent {
  public languages: SelectItem[] = [{value: 'it', label: 'Italian' },{value: 'en', label: 'English' }];
  public selectedLanguage: string;

  public menuInactiveDesktop: boolean;

  public menuActiveMobile: boolean;

  public profileActive: boolean;

  public topMenuActive: boolean;

  public topMenuLeaving: boolean;

  @ViewChild('scroller') public scrollerViewChild: ElementRef;

  public scroller: HTMLDivElement;

  documentClickListener: Function;

  menuClick: boolean;

  topMenuButtonClick: boolean;

  menuIcon: string = 'fa-angle-left';

  cardsLengthParamKey = 'CARDS.NUMERIC.LENGHT';

  appVersion = environment.VERSION;

  ready = {
    menu: null
  }
  
  constructor(
    public renderer: Renderer,
    private authService: AuthService,
    private router: Router,
    private userService: UsersService,
    private localStorageService: LocalStorageService,
    private translate: TranslateService,
    private localizedNumbersService: NgxLocalizedNumbersService,
    public appRef: ApplicationRef,
    public appComponent: AppComponent,
    public zone: NgZone,
    private cardService: LoyaltyCardService
  ) {
    this.appComponent.cssClass = 'main-body';
    this.selectedLanguage = authService.sessionHelper.selectedLanguage;
    if (!this.isDesktop())
    {
      this.menuIcon = 'fa-bars';
    }
  }
  logOut() : void {
    console.log('logout request...');    
    this.authService.logout();
  }

  goToProfile() : void {
    console.log('going to profile view...');

   this.router.navigateByUrl('profile');
  }
  ngOnInit(){
    this.ready.menu = true;
    this.cardService.getCardsLength().subscribe(
      res => {
        sessionStorage.setItem('cardsLength', "99");
        let cardsLength = res.find(e => e.param_key === this.cardsLengthParamKey);
        if (cardsLength.param_code && cardsLength.param_code !== 0) {
          sessionStorage.setItem('cardsLength', cardsLength.param_code);
        }
      },
      err => sessionStorage.setItem('cardsLength', "99")
    );
  }
  ngAfterViewInit() {

    this.scroller = <HTMLDivElement> this.scrollerViewChild.nativeElement;

    //hides the overlay menu and top menu if outside is clicked
    this.documentClickListener = this.renderer.listenGlobal('body', 'click', (event) => {
      if(!this.isDesktop()) {
        if(!this.menuClick) {
          this.menuActiveMobile = false;
        }

        if(!this.topMenuButtonClick) {
          this.hideTopMenu();
        }

        this.menuClick = false;
        this.topMenuButtonClick = false;
      }

    });

  }

  onResize (event: Event) {
      if (this.isDesktop () && this.menuInactiveDesktop) {
          this.menuIcon = 'fa-bars';
      } else if (this.isDesktop ()) {
          this.menuIcon = 'fa-angle-left';
      } else if (this.menuActiveMobile) {
          this.menuIcon = 'fa-angle-left';
      } else {
          this.menuIcon = 'fa-bars';
      }
  }

  toggleMenu(event: Event) {
    var homeClass = this;
    setTimeout ( function () {
      if (homeClass.menuIcon == 'fa-angle-left') {
        homeClass.menuIcon = 'fa-bars';
      } else {
        homeClass.menuIcon = 'fa-angle-left';
      }
      window.dispatchEvent(new Event('resize'));

    }, 300);
    this.menuClick = true;
    if(this.isDesktop()) {
      this.menuInactiveDesktop = !this.menuInactiveDesktop;
      if(this.menuInactiveDesktop) {
        this.menuActiveMobile = false;
      }
    }
    else {
      this.menuActiveMobile = !this.menuActiveMobile;
      if(this.menuActiveMobile) {
        this.menuInactiveDesktop = false;
      }
    }

    if(this.topMenuActive) {
      this.hideTopMenu();
    }

    event.preventDefault();
  }

  toggleProfile(event: Event, panel: OverlayPanel) {
    //this.profileActive = !this.profileActive;
    panel.toggle(event);
    event.preventDefault();
  }

  toggleTopMenu(event: Event) {
    this.topMenuButtonClick = true;
    this.menuActiveMobile = false;

    if(this.topMenuActive) {
      this.hideTopMenu();
    }
    else {
      this.topMenuActive = true;
    }

    event.preventDefault();
  }

  hideTopMenu() {
    this.topMenuLeaving = true;
    setTimeout(() => {
      this.topMenuActive = false;
      this.topMenuLeaving = false;
    }, 500);
  }

  onMenuClick(event: any) {
    this.menuClick = true;
  }

  isDesktop() {
    return window.innerWidth > 1024;
  }

  onSearchClick(event: any) {
    this.topMenuButtonClick = true;
  }

  ngOnDestroy() {
    if(this.documentClickListener) {
      this.documentClickListener();
    }
  }
  languageChange() {
    console.log('language change');
    console.log(this.selectedLanguage);
    this.authService.sessionHelper.selectedLanguage = this.selectedLanguage;
    this.ready.menu = false;
    sessionStorage.removeItem('menu');
    this.translate.use(this.selectedLanguage).subscribe(() => {
      this.authService.sessionHelper.selectedLanguage = this.selectedLanguage;
      this.authService.user.language = this.selectedLanguage;
      this.appRef.tick()
      this.userService.getApplicationsForUserCompany(this.authService.user.id, this.authService.user.selectedCompany).subscribe(
        (res) => {
          this.translate.reloadLang(this.translate.currentLang);
          this.authService.user.enabledUserApps = res;
          sessionStorage.setItem('userData',JSON.stringify(this.authService.user));
        })
      this.zone.run(() => {
        if (this.selectedLanguage === 'it') {
          console.log('LANGUAGE CHANGE, LOCALE NUMBER SET TO it_IT');
          this.localizedNumbersService.setLocale(this.selectedLanguage + '_IT');
        } else if (this.selectedLanguage === 'en') {
          console.log('LANGUAGE CHANGE, LOCALE NUMBER SET TO en_US');
          this.localizedNumbersService.setLocale(this.selectedLanguage + '_US')
        }
        var self = this;

        setTimeout(function(){
          self.ready.menu = true;
          self.router.navigateByUrl('/');
        },500);



      })
    });
  }

}



// WEBPACK FOOTER //
// ./src/app/views/homepage/homepage.component.ts